import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';

const languages = [
  { code: 'it', label: 'IT', dir: 'ltr' },
  { code: 'en', label: 'EN', dir: 'ltr' },
  { code: 'fr', label: 'FR', dir: 'ltr' },
  { code: 'es', label: 'ES', dir: 'ltr' },
  { code: 'ru', label: 'RU', dir: 'ltr' },
  { code: 'ar', label: 'AR', dir: 'rtl' },
  { code: 'zh', label: '中文', dir: 'ltr' },
  { code: 'hi', label: 'HI', dir: 'ltr' },
];

const LanguageSwitcher = ({ dropUp = false }: { dropUp?: boolean }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = languages.find((l) => l.code === i18n.language) || languages[0];

  const switchLang = (code: string, dir: string) => {
    i18n.changeLanguage(code);
    document.documentElement.dir = dir;
    document.documentElement.lang = code;
    setOpen(false);
  };

  return (
    <div className="relative w-fit" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} onClick={() => setOpen(!open)}>
      <button className="flex items-center gap-1 text-sm tracking-[0.1em] text-muted-foreground hover:text-primary transition-colors">
        {current.label}
        <ChevronDown className={`w-3 h-3 transition-transform ${dropUp ? 'rotate-180' : ''}`} />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: dropUp ? -4 : 4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: dropUp ? -4 : 4 }}
            className={`absolute z-50 ${dropUp ? 'bottom-full mb-2 left-0' : 'top-full mt-2 left-1/2 -ml-10'} w-20 bg-card border border-border rounded-sm shadow-xl`}
          >
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => switchLang(lang.code, lang.dir)}
                className={`block w-full text-center px-3 py-2 text-sm hover:bg-secondary/50 transition-colors ${
                  lang.code === current.code ? 'text-primary' : 'text-muted-foreground'
                }`}
              >
                {lang.label}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LanguageSwitcher;
